var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.WidgetBaseComponent, {
    staticClass: "expedient-summary-widget",
    attrs: { loadedData: _setup.allDataLoaded && !_setup.showSpinner },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [_c("h2", [_vm._v(_vm._s(_setup.expedientSummaryData.title))])]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "section",
              { staticClass: "expedient-summary-widget-container" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "resize",
                        rawName: "v-resize",
                        value: _setup.checkTruncation,
                        expression: "checkTruncation",
                      },
                    ],
                    staticClass: "expedient-info",
                  },
                  _vm._l(_setup.infoItems, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "info-item" },
                      [
                        _setup.isTruncatedItems[index]
                          ? _c(_setup.PhoneListTooltip, {
                              attrs: {
                                item: item,
                                index: index,
                                isTruncated: _setup.isTruncatedItems[index],
                              },
                            })
                          : _c(
                              "div",
                              { staticClass: "row-info" },
                              [
                                Array.isArray(item.data)
                                  ? [
                                      _c(_setup.PhoneListComponent, {
                                        attrs: {
                                          label: item.label,
                                          data: item.data,
                                          index: index,
                                        },
                                        on: { setRef: _setup.setRef },
                                      }),
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        { staticClass: "info-item-label" },
                                        [_vm._v(_vm._s(`${item.label}:`))]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "info-item-data-large" },
                                        [_vm._v(_vm._s(item.data))]
                                      ),
                                    ],
                              ],
                              2
                            ),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "resumes-container" },
                  _vm._l(_setup.parseResumeCounters, function (counter, index) {
                    return _c(
                      "div",
                      { key: `counter-${index}`, staticClass: "resume-item" },
                      [
                        _c("span", {
                          class: [_setup.renderIcon(index), "lf-icon__md"],
                        }),
                        _c("div", { staticClass: "resume-item-container" }, [
                          _c("span", { staticClass: "resume-item-title" }, [
                            _vm._v(_vm._s(counter.title)),
                          ]),
                          _c("span", { staticClass: "resume-item-qty" }, [
                            _vm._v(_vm._s(counter.qty)),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "tooltip-container" },
                          [
                            _c(_setup.LexonTooltipComponent, {
                              attrs: {
                                icon: _setup.icon.tooltip,
                                message: counter.message,
                                position: "right",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }